import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import { Transition, TransitionGroup } from "react-transition-group";
import {
    selectWeekCount,
    selectRowCount,
    selectArrangedJobpacksAsArray,
    selectSelectedJobpackID,
    selectRawJobpacks,
} from "./selectors";
import Event from "./Event";

const EventRowContainer = styled.div`
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: ${(props) => props.weekCount * 7 + 2};
    box-sizing: border-box;
    position: relative;
    pointer-events: none;
`;

class EventsContainer extends React.Component {
    render() {
        const {
            rowCount,
            duration,
            arrangedJobpacksAsArray,
            weekCount,
            selectedJobpackID,
        } = this.props;

        return (
            <EventRowContainer weekCount={weekCount}>
                <TransitionGroup component={null}>
                    {arrangedJobpacksAsArray.map((e, i) => {
                        return (
                            <Transition key={i} appear timeout={duration}>
                                {(transitionStatus) => {
                                    return (
                                        <Event
                                            key={i}
                                            event={e}
                                            weekCount={weekCount}
                                            rowCount={rowCount}
                                            duration={duration}
                                            transitionStatus={transitionStatus}
                                            rowIndex={e.row}
                                            selected={
                                                e.uid === selectedJobpackID
                                            }
                                            jobpackProfile={
                                                this.props.jobpacks[e.uid]
                                                    .profile
                                            }
                                        />
                                    );
                                }}
                            </Transition>
                        );
                    })}
                </TransitionGroup>
            </EventRowContainer>
        );
    }
}

export default hot(module)(
    React.memo(
        connect((store) => {
            return {
                weekCount: selectWeekCount(store),
                rowCount: selectRowCount(store),
                arrangedJobpacksAsArray: selectArrangedJobpacksAsArray(store),
                selectedJobpackID: selectSelectedJobpackID(store),
                jobpacks: selectRawJobpacks(store),
            };
        }, {})(EventsContainer)
    )
);
